import {ReactComponent as AndroidLight} from "../../../assets/svg/android.svg";
import {ReactComponent as AndroidDark} from "../../../assets/svg/android-dark.svg";
import {ReactComponent as IosLight} from "../../../assets/svg/apple.svg";
import {ReactComponent as IosDark} from "../../../assets/svg/apple-dark.svg";
import {ReactComponent as WebLight} from "../../../assets/svg/windows.svg";
import {ReactComponent as WebDark} from "../../../assets/svg/web-dark.svg";


export const platformIconsLight = {
  android: AndroidLight,
  ios: IosLight,
  web: WebLight,
};


export const platformIconsDark = {
  android: AndroidDark,
  ios: IosDark,
  web: WebDark,
};

